import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { NegocioGuard } from "./shared";
import NegocioDashboard from "./Dashboard";
import CustomersPage from "./Customers";
import ProductsPage from "./Products";
import AccountsPage from "./Accounts";
import CombosPage from "./Combos";
import SalesPage from "./Sales";
import ServicesPage from "./Services";
import CollectionsPage from "./Collections";
import SuppliersPage from "./Suppliers";
import SettingsPage from "./Settings";
import PublicidadPage from "./Publicidad";
import WatoolxClientsPage from "./WatoolxClients";
import EmailsPage from "./Emails";
import OrdersPage from "./Orders";
import { BinancePaymentHost } from "./BinanceCheckoutDialog";

const keepSearch = (pathname) => ({ location }) => (
  <Redirect to={{ pathname, search: location.search }} />
);

export default function NegocioPage() {
  return (
    <NegocioGuard>
      <Switch>
        <Route exact path="/negocio" component={NegocioDashboard} />
        <Route exact path="/negocio/clientes" component={CustomersPage} />
        <Route exact path="/negocio/pedidos" component={OrdersPage} />
        <Route exact path="/negocio/servicios" component={ServicesPage} />
        <Route exact path="/negocio/cobros" component={CollectionsPage} />
        <Route exact path="/negocio/ingresos" component={SalesPage} />
        <Route exact path="/negocio/publicidad" component={PublicidadPage} />
        <Route exact path="/negocio/watoolx" component={WatoolxClientsPage} />
        <Route exact path="/negocio/suscripciones" render={keepSearch("/negocio/cobros")} />
        <Route exact path="/negocio/ventas" render={keepSearch("/negocio/ingresos")} />
        <Route exact path="/negocio/cuentas" component={AccountsPage} />
        <Route exact path="/negocio/correos" component={EmailsPage} />
        <Route exact path="/negocio/productos" component={ProductsPage} />
        <Route exact path="/negocio/combos" component={CombosPage} />
        <Route exact path="/negocio/proveedores" component={SuppliersPage} />
        <Route exact path="/negocio/pagos" render={() => <SettingsPage tab="pagos" />} />
        <Route exact path="/negocio/configuracion/usuarios" render={() => <Redirect to="/users" />} />
        <Route exact path="/negocio/configuracion" render={() => <SettingsPage tab="planes" />} />
        <Route exact path="/negocio/configuracion/:tab" component={SettingsPage} />
      </Switch>
      <BinancePaymentHost />
    </NegocioGuard>
  );
}
